
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
  Program Manager (Lead MGNF) - SANKALP
</h2>

<p class="para_main_notify">
  Skills Acquisition and Knowledge Awareness for Livelihood Promotion (SANKALP) is an outcome-oriented centrally sponsored program supported by World Bank.
</p>
  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">


                    <!-- feature box begin -->
                    <div class="col-md-12 feature-box mb40 sq-item wow">
                      <div class="feature-box style-2 left">
                        <i class="fa fa-tasks" aria-hidden="true"></i>
                        <div class="text para_cls">
                          <h3>	Project Background:</h3>
                          <p> SANKALP focuses on the overall skilling ecosystem covering both Central and State agencies, and outcomes are measured through Disbursement Linked Indicators (DLIs) agreed between MSDE and the World Bank. Under SANKALP the following key result areas have been identified viz: </p>
                            <p> <span class="step_no">1</span>Creating and building capacities of the institutions involved in planning and delivery of skill development at national, states and district levels  </p>
                            <p> <span class="step_no">2</span>	Quality Assurance of skill development programs for better outcomes  </p>
                            <p> <span class="step_no">3</span>	Inclusion of marginalised in skill development  </p>
                        </div>
                      </div>
                    </div>
                    <!-- feature box close -->

            <!-- feature box begin -->
            <div class="col-md-12 feature-box mb40 sq-item wow">
              <div class="feature-box style-2 left">
                <i class="fa fa-gavel" aria-hidden="true"></i>
                <div class="text para_cls">
                  <h3>	Key responsibilities:</h3>
                  <p> <b> Program Manager (Lead MGNF) shall be overall responsible for the following activities: </b> </p>
                    <p> <span class="step_no">1</span>Overall leadership for the implementation of Mahatma Gandhi National Fellowship (MGNF) including HR and travel management of Fellows, grievances redressal, coordination and overall management of the programme</p>
                    <p> <span class="step_no">2</span>Coordination with the team (including other experts in the PMU) to ensure all project deliverables are produced within time and ensure quality for the programme</p>
                    <p> <span class="step_no">3</span>Liaising and Stakeholder management (including Officials in States/Districts and representatives of IIMs involved under the programme)</p>
                    <p> <span class="step_no">4</span>Coordinate with the SSDMs and districts whenever required for smooth conduct of the program</p>
                    <p> <span class="step_no">5</span>Coordinate with the Program Managers and State Resource Associates (SRAs) appointed by the Academic Partners (IIMs) on day today basis for smooth conduct of the program. </p>
                    <p> <span class="step_no">6</span>Work with HR team to ensure timely payments to the fellows on the basis of their monthly attendance and coordinate for travel arrangements of Fellows to the academic institution;</p>
                    <p> <span class="step_no">7</span>Supervision of the programme management reports shared by Regional Managers, HR expert, Finance Expert and IT Expert.</p>
					<p> <span class="step_no">8</span>Prepare Monthly Progress Reports (both technical and financial) to be submitted to Ministry</p>
					<p> <span class="step_no">9</span>Any other tasks/functions as assigned by NIMI/MSDE.</p>
                </div>
              </div>
            </div>
            <!-- feature box close -->

        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Qualification: </h3>
              <p> <span class="step_no">1</span>MBA / Masters in any discipline</p>
			  <p> <span class="step_no">2</span>Masters in  Social Sciences / Social Work/Development Studies / Business Administration/Rural Management/ Engineering or Technology / Operations Research or related fields from a reputed academic institution is preferred</p>




            </div>
          </div>
        </div>
        <!-- feature box close -->




  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>Experience:</h3>
        <p> <span class="step_no">1</span>At least ten (10) years of overall experience and minimum of 3 years of experience in the development sector and exposure to government sector is preferred</p>

       </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p> Rs. 80,000/- consolidated pay from which standard TDS will be deducted at source. Not entitled to any other allowance or benefits. </p>

      </div>
    </div>
  </div>
  <!-- feature box close -->
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b></b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Skills and Competencies:</h3>
        <p><span class="step_no">1</span>Strong command of both English and Hindi as working languages (verbal and written)</p>
        <p><span class="step_no">2</span>Excellent technical vision, management and leadership skills to manage diverse stakeholders</p>
        <p><span class="step_no">3</span>Excellent planning, reporting and risk management skills</p>

      </div>
    </div>
  </div>
  <!-- feature box close -->


    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Nature of engagement:</h3>
        <p><span class="step_no">1</span>The appointment to the post will be purely on contract basis initially for a period of one year, further extendable subject to satisfactory performance and requirement of services for another year.</p>
		<p><span class="step_no">2</span>The performance of the consultant will be reviewed every year and the contract shall be extended or discontinued (as the case may be) depending on the performance. The decision of NIMI shall be final in this regard.</p>


      </div>
    </div>
  </div>
  <!-- feature box close -->
    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Locations</h3>
        <p><span class="step_no">1</span>Chennai</p>





      </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Selection Process:</h3>
        <p><span class="step_no">1</span>Selection will be done on the basis of performance in the personal interview by a selection committee.</p>
		<p><span class="step_no">2</span>Only shortlisted candidates will be called for the interview.</p>
		<p><span class="step_no">3</span>No TA/DA will be paid for attending the interview.</p>
<p><span class="step_no">4</span>At the time of the interview, the candidates shall produce their original certificates for verification. </p>

      </div>
    </div>
  </div>
  <!-- feature box close -->

     <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Attendance and leave policy:</h3>
        <p><span class="step_no">1</span>The working hours will be the same as for NIMI.</p>
		<p><span class="step_no">2</span>No extra remuneration shall be paid for working beyond office hours or on Saturdays/Sundays/gazetted holidays.</p>
<p><span class="step_no">3</span>Compulsory leave in such cases shall be at the discretion of the competent authority.</p>

      </div>
    </div>
  </div>
  <!-- feature box close -->

    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Confidentiality and secrecy :</h3>
        <p><span class="step_no">1</span>The consultant maintain confidentiality and will not divulge any information gathered during the period of engagement with the NIMI to any person who is not authorised to know the same. </p>



      </div>
    </div>
  </div>
  <!-- feature box close -->

   <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Documents for attending the Test and Interview :</h3>
        <p><span class="step_no">1</span>2 copies of passport size photographs</p>
		<p><span class="step_no">2</span>Original and self attested copies of educational certificates</p>
		<p><span class="step_no">3</span>Original and self attested copies of  Caste certificate  and Aadhar card </p>
		<p><span class="step_no">4</span>Original  and self attested copies of Experience certificates </p>



      </div>
    </div>
  </div>
  <!-- feature box close -->


<!--
  <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div> -->


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>
